export default "__VITE_ASSET__12d1f1f3__"